module.exports = "<div id=\"alert-message\" class=\"alert\"></div>\n<face-header app-user=\"$ctrl.appUser\" ng-class=\"$state.is('app.face.dataSmart') ? 'reverse':''\"></face-header>\n<div ui-view></div>\n<ybfooter></ybfooter>\n<language></language>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/face.html
// module id = 778
// module chunks = 3